import { createGlobalStyle } from 'styled-components';

/**
 * Presentation for the pinned and recent rows of the Export Report menu. The rows
 * render in antd's Dropdown portal, out of reach of any styled wrapper, so these
 * are global rules, matched only through the `user-template-option*` classes the
 * rows carry. Mounted by ExportReport.
 */
export const UserTemplateOptionsStyles = createGlobalStyle`
  .ant-dropdown-menu,
  .ant-dropdown,
  .ant-menu {
    .ant-dropdown-menu-item,
    .ant-menu-item {
      /* The flash overlay is the row's background while it is highlighted. */
      &.user-template-option-highlighted,
      &.user-template-option-highlighted:hover,
      &.user-template-option-highlighted:active,
      &.user-template-option-highlighted.ant-dropdown-menu-item-active,
      &.user-template-option-highlighted.ant-menu-item-active {
        background-color: transparent !important;
      }

      &.user-template-option-pinned:not(:hover):not(:focus-visible):not(.user-template-option-highlighted),
      &.user-template-option-recent:not(:hover):not(:focus-visible):not(.user-template-option-highlighted) {
        &:active,
        &.ant-dropdown-menu-item-active,
        &.ant-menu-item-active,
        &.ant-dropdown-menu-item-selected,
        &.ant-menu-item-selected {
          background-color: transparent !important;
        }
      }
    }
  }

  .ant-dropdown-menu-item.user-template-option-recent .user-template-option-pin {
    opacity: 0;
  }

  .ant-dropdown-menu-item.user-template-option-recent:hover .user-template-option-pin,
  .ant-dropdown-menu-item.user-template-option-recent:focus-visible .user-template-option-pin {
    opacity: 1;
  }

  /* antd's vertical item is one line tall with nowrap. These rows wrap, so the
     height follows the label and the pin controls stay on the first line.
     Two classes on the menu beat antd's own item rule. */
  .ant-dropdown-menu.ant-dropdown-menu-vertical
    .ant-dropdown-menu-item.user-template-option-pinned,
  .ant-dropdown-menu.ant-dropdown-menu-vertical
    .ant-dropdown-menu-item.user-template-option-recent {
    align-items: flex-start;
    display: flex;
    height: auto;
    line-height: 22px;
    max-width: 100%;
    min-height: 40px;
    overflow: hidden;
    padding-block: 8px;
    position: relative;
    text-overflow: unset;
    white-space: normal;
  }

  /* Its own stacking context, so the flash overlay (z-index -1, see
     UserTemplateOptionItem.style.tsx) paints above the row's background and
     beneath its text. */
  .ant-dropdown-menu-item.user-template-option-highlighted {
    isolation: isolate;
  }

  .ant-dropdown-menu-item.user-template-option-pinned.ant-dropdown-menu-item-disabled,
  .ant-dropdown-menu-item.user-template-option-recent.ant-dropdown-menu-item-disabled {
    pointer-events: auto;
  }

  /* A disabled row keeps its place in the arrow-key order (its pin shortcuts still
     apply), so it needs the same focus highlight as an enabled one. The dark theme
     in DropdownStyles clears a disabled row's active background; this is later at
     equal specificity, so it wins for keyboard focus only. */
  .ant-dropdown-menu-item.user-template-option-pinned.ant-dropdown-menu-item-disabled:focus-visible,
  .ant-dropdown-menu-item.user-template-option-recent.ant-dropdown-menu-item-disabled:focus-visible {
    background-color: ${({ theme }) => theme.activeMenuItemBackgroundColor} !important;
  }
`;
